import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  header: {
    display: 'inline-block',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    textAlign: 'center',
  },
  mainHeader: {
    float: 'left',
    fontSize: '24px',
    fontWeight: 800,
    lineHeight: '28px',
  },
  secondHeader: {
    marginRight: '14px',
    float: 'right',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  spanHeader: {
    fontWeight: 800,
  },
}));
